import React from 'react'
import "../App.css";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const Page6 = (rond) => {
    let { round } = rond;
    round = round -1;
    round = round / 4;

    const location = useLocation();
    const allEncResults = location.state.allEncResults;

    const icon = {
      hidden: {
        x: -700,
      },
      visible: {
        x: 0,
        transition: {
          delay: 0.25,
          duration: 1,
        },
      },
    };
  
    const transposedData = allEncResults[5][round + 1][0].map((col, columnIndex) =>
    allEncResults[5][round + 1].map((row) => row[columnIndex])
  );

  const transposedData1 = allEncResults[4][round].map((col, columnIndex) =>
    allEncResults[4][round].map((row) => row[columnIndex])
  );
    
  
    return (
      <>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h2 className=" font-semibold text-2xl">Round {round+1}</h2>
            <h2 className=" font-semibold text-xl">Step 4</h2>
            <h2 className=" font-semibold text-xl">XOR with Subkey</h2>

            <div className="grid grid-flow-col grid-cols-4 gap-2 align-middle pt-28">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className=" bg-emerald-100 rounded-xl w-auto">
                  <tbody className="">
                    <tr>
                      <td  className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 ">{allEncResults[3][round][0].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div></td>
                    </tr>
                    <tr>
                      <td  className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 ">{allEncResults[3][round][1].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div></td>
                    </tr>
                    <tr>
                      <td  className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 ">{allEncResults[3][round][2].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div></td>
                    </tr>
                    <tr>
                      <td  className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 ">{allEncResults[3][round][3].map(item => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0')}</div></td>
                    </tr>
                  </tbody>
                </table>
                <p className="align-middle"> After multiplication</p>
              </motion.div>

              <div className=" pt-20 pl-7">
                <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>

              <motion.div>
              <table className="bg-emerald-100 rounded-xl w-auto">
      <tbody>
        {/* Map through the transposed data and create rows for each column */}
        {transposedData.map((column, columnIndex) => (
          <tr key={columnIndex}>
            <td className="px-6 py-4 whitespace-nowrap">
              <div className="text-sm text-gray-900">
                {/* Join the characters in each item and display in a single row */}
                {column.map((item) => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 ')}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
                
                <p className="align-middle"> Used Subkey for XOR<br />This is the Subkey no.{round+1} from key input</p>
              </motion.div>


              <div className=" pt-20 pl-7">
                <svg
                  width="170"
                  height="38"
                  viewBox="0 0 573 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <motion.path
                    variants={icon}
                    initial="hidden"
                    animate="visible"
                    d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
                    fill="black"
                  />
                </svg>
              </div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2 }}
                className="w-fit"
              >
                <table className="bg-emerald-100 rounded-xl w-auto border hover:border-cyan-500">
      <tbody>
        {/* Map through the transposed data and create rows for each column */}
        {transposedData1.map((column, columnIndex) => (
          <tr key={columnIndex}>
            <td className="px-6 py-4 whitespace-nowrap">
              <div className="text-sm text-gray-900">
                {/* Join the characters in each item and display in a single row */}
                {column.map((item) => item.split('').join('')).join(' \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0 ')}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
                <p className="align-middle"> After XOR(Final o/p of round)</p>
              </motion.div>

            </div>
          </div>
        </div>
      </div>

    </>
    )
}

export default Page6